import { render, staticRenderFns } from "./DataImport.vue?vue&type=template&id=5f0b3bde&scoped=true"
import script from "./DataImport.vue?vue&type=script&lang=js"
export * from "./DataImport.vue?vue&type=script&lang=js"
import style0 from "./DataImport.vue?vue&type=style&index=0&id=5f0b3bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b3bde",
  null
  
)

export default component.exports